import React from 'react';
import { CLASSNAME_PREFIX, TRANSLATION_CONTEXT } from '../componentConfig';

var VerificationInProgress = function VerificationInProgress(_ref) {
  var t = _ref.t;
  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification__info' },
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-account-verification__unverified' },
      t(TRANSLATION_CONTEXT)('accountVerification.inProgress.verificationInProgress')
    ),
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-account-verification__spaced' },
      t(TRANSLATION_CONTEXT)('accountVerification.inProgress.verificationInProgressInfo')
    )
  );
};

export default VerificationInProgress;